import * as React from 'react';
import { Link, LazyImage } from '@grandvisionhq/common';
import { Heading } from '@grandvisionhq/elements';

const FooterSocialLinks = ({ title , items  })=>{
    if (!items.length) {
        return null;
    }
    var _alt;
    return /*#__PURE__*/ React.createElement("section", {
        className: "footer__section footer__social"
    }, title && /*#__PURE__*/ React.createElement(Heading, {
        variant: "smallest",
        component: "div",
        className: "footer-section__title"
    }, title), /*#__PURE__*/ React.createElement("ul", {
        className: "footer__social-links"
    }, items.map((item, index)=>item.link && item.image && /*#__PURE__*/ React.createElement("li", {
            key: `footer-social-link-${index}`,
            className: "footer__social-links-item"
        }, /*#__PURE__*/ React.createElement(Link, {
            className: "footer__social-link",
            url: item.link.url,
            target: item.link.openInNewWindow ? 'external' : undefined,
            labelAccessibility: (_alt = item.link.alt) !== null && _alt !== void 0 ? _alt : ''
        }, /*#__PURE__*/ React.createElement(LazyImage, {
            className: "footer__social-image",
            src: item.image.url,
            alt: "",
            height: 32,
            width: 32
        })))
    )));
};

export { FooterSocialLinks };
//# sourceMappingURL=FooterSocialLinks.js.map
